import * as React from 'react';
export function getDataSourceFromChildren(children) {
    if (!children) {
        return [];
    }
    return React.Children.map(children, (child) => {
        const { value, text, children: childText, ...rest } = child.props;
        return {
            value,
            label: childText || text,
            ...rest,
        };
    });
}
function normalizeDataSource(dataSource) {
    if (!Array.isArray(dataSource))
        return [];
    const source = [];
    dataSource.forEach((item) => {
        // enable array of basic type
        if (/string|boolean|number/.test(typeof item) ||
            item === null ||
            item === undefined) {
            item = { label: `${item}`, value: item };
        }
        source.push(item);
    });
    return source;
}
export function getDataSource(dataSource, children) {
    let ds = normalizeDataSource(dataSource);
    if (!dataSource && React.Children.count(children) > 0) {
        ds = getDataSourceFromChildren(children);
    }
    return ds || [];
}
export function isValidArray(obj) {
    return Array.isArray(obj) && obj.length > 0;
}
export function findInArray(arr = [], fn) {
    let ret = null;
    if (isValidArray(arr)) {
        arr.forEach((item, index) => {
            if (!ret && fn(item, index)) {
                ret = item;
            }
        });
    }
    return ret;
}
export function isNumber(num) {
    if (num === '' || num === null) {
        return false;
    }
    return (typeof num === 'number' && !isNaN(num)) || !isNaN(Number(num));
}
/**
 * 判断变量是否未定义
 * @param obj
 */
export function isUndef(obj) {
    return typeof obj === 'undefined';
}
export function isNil(val) {
    return typeof val === 'undefined' || val === null;
}
/**
 * 合并两个数据
 * 注意： 只对 value 做对比， 如果 value 相同，则会忽略
 *  eg:
 *    mergeDataSource([{label:1, value:1}, {label:2, value:2}], [{label: 1, value:1}]) => [{label:1, value:1}, {label:2, value:2}]
 * @param ds1
 * @param ds2
 */
export function mergeDataSource(ds1, ds2) {
    const tmpArr = [];
    ds2.forEach((it) => {
        if (it?.value &&
            !findInArray([...ds1, ...tmpArr], (_it) => _it.value === it.value)) {
            tmpArr.push(it);
        }
    });
    return [...tmpArr, ...ds1];
}
export function replaceMessage(template, kv) {
    return template.replace(/\${\w+}/g, (str) => {
        const key = str.slice(2, -1);
        return kv[key];
    });
}
export function stopPropagation(e) {
    if (!e) {
        return;
    }
    if (e.stopPropagation) {
        e.stopPropagation();
        return;
    }
    if (typeof e.originalEvent === 'object' && e.originalEvent.stopPropagation) {
        e.originalEvent.stopPropagation();
    }
}
